import type { BlockContentAndBanner } from 'types/block-content-and-banner';
import React from 'react';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import Figure from './figure';

const ContentAndBanner: React.FC<BlockContentAndBanner> = ({
  sectionId,
  title,
  backgroundColor = 'beige',
  contentRight,
  contentLeft,
  bannerTitle,
  bannerLabel,
  bannerImage,
}) => {
  const hasContent = contentRight?.length > 0 || contentLeft?.length > 0;
  const hasBanner =
    bannerTitle?.length > 0 || bannerLabel?.length > 0 || bannerImage;

  return (
    <section
      id={sectionId}
      className={
        backgroundColor !== 'none'
          ? 'my-10 md:my-12 lg:mt-12 bg-[#FFFAF8] border border-gray-200'
          : null
      }
    >
      <Wrap className={hasBanner ? '!pb-0' : ''}>
        {title?.length > 0 && (
          <HeadingBody
            className="text-center lg:text-left font-semibold"
            level="2"
            title={title}
          />
        )}
        {hasContent ? (
          <div className="grid lg:grid-cols-2 lg:gap-x-14">
            {contentLeft?.length > 0 && (
              <WysiwygContent content={contentLeft} className="flex flex-col" />
            )}
            {contentRight?.length > 0 && (
              <WysiwygContent
                content={contentRight}
                className="lg:justify-self-end"
              />
            )}
          </div>
        ) : null}
        {hasBanner ? (
          <div
            className={[
              'grid gap-y-10',
              hasContent ? 'lg:grid-cols-2' : 'justify-items-center',
            ].join(' ')}
          >
            <div
              className={
                hasContent ? 'text-center lg:text-left' : 'text-center'
              }
            >
              {bannerTitle?.length > 0 && (
                <HeadingBody
                  className="!mb-2 font-semibold"
                  tagName="p"
                  level="2"
                  title={bannerTitle}
                />
              )}
              {bannerLabel?.length > 0 ? (
                <p
                  className={['mt-4', hasContent ? 'lg:max-w-sm' : ''].join(
                    ' ',
                  )}
                >
                  {bannerLabel}
                </p>
              ) : null}
            </div>
            {bannerImage && (
              <div
                className={[
                  hasContent ? 'flex justify-center lg:justify-end' : '',
                ].join(' ')}
              >
                <Figure {...bannerImage} className="max-w-lg" />
              </div>
            )}
          </div>
        ) : null}
      </Wrap>
    </section>
  );
};

export default ContentAndBanner;
